import { useEffect, useState } from "react";
import Layout from "../../Layout/Layout";
import { useNavigate } from "react-router-dom";
import EventService from "../../service/EventService"
import { AuthService } from "../../service/AuthService";
import { Pagination, Select } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ModeIcon from '@mui/icons-material/Mode';


function EventList() {
    const [eventList, setEventList] = useState([]);
    const [pageCount, setpageCount] = useState(10);
    const [paginationCount, setPaginationCount] = useState(null)
    const [totalRecord,setTotalRecord]= useState()
    const [pages, setPage] = useState(1);
    
    const navigate = useNavigate();

    const setpageHandler = (e) => {
        setpageCount(e)
        setPage(1)
    }
    
    const handleChange = (e, p) => {
        setPage(p);
    }
   
    const getEventListByPaging = async (text) => {
        const formData = {
            CreatedBy: AuthService.getCurrentUser().userId,
            PageIndex: pages,
            PageSize: pageCount,
            Filter: text
        }
        try {
            const res = await EventService.GetEventList(formData);
            const data = JSON.parse(res.apiData);
            setEventList(data);
            setPaginationCount(Math.ceil(res.recordCount / pageCount))
            setTotalRecord(res.recordCount);  
            
        } catch (error) {
            console.warn(error);
        }
    }
   

    const AddOrEditEventForm = (eventId) => {
        try {
            if (eventId) {
                navigate({
                    pathname: '/eventform',
                    search: "id=" + eventId,
                })
            }
        } catch (error) {

        }
    }

    const eventsPerPages=[10,20,30,40,50,60,70,80,90,100];

    useEffect(() => {
        if(AuthService.isAuthenticatedUser())  {
            getEventListByPaging();
        } else{
            navigate('/')
        }
    }, [pageCount,pages])


    return (
        <>
            <Layout>
                <div className="container mx-auto max-sm:min-h-screen">
                    {/* header */}
                    <div className="shadow-sm shadow-gray-600 flex max-sm:flex-col gap-5 sm:mt-28 py-3 sm:px-14 max-sm:px-2 justify-end"> 
                    <h1 className="sm:text-5xl text-3xl  text-center w-full text-orange-600 font-bold">Scheduled Event List</h1>
                        <button onClick={() => navigate('/eventform')} className="py-2  px-3 border border-orange-400 rounded-xl bg-orange-500 font-semibold sm:w-52 text-white hover:bg-orange-600"><AddCircleOutlineIcon/> Add New Event</button>
                    </div>

                    {/* search input section */}
                    <div className="flex justify-around items-end my-3 px-10">
                        <input onChange={(e)=>getEventListByPaging(e.target.value)} className="sm:w-1/2 max-sm:w-3/4 rounded-xl focus:border-none outline-none focus:outline-orange-500" placeholder="search..." />
                    </div>

                    {/* event list section */}
                    <div className="container mx-2 min-h-72 max-sm:overflow-auto max-sm:pr-3 w-full ">{
                        eventList ?
                            <table className="w-full border border-black">
                                <thead >
                                    <tr className="bg-orange-500 text-white">
                                        <th>CountryName</th>
                                        <th>Description</th>
                                        <th>StartDate</th>
                                        <th>EndDate</th>
                                        <th>AppType</th>
                                        <th>Edit</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        eventList.map((event) => {
                                            let appType='';
                                            if(event.AppType===1){
                                                appType='Mobile'
                                            } else if(event.AppType===2){
                                                appType='Web'
                                            } else{
                                                appType='All'
                                            }
                                            return (
                                                <tr className="border border-black " key={event.EncEventID}>
                                                    <td className=" text-center">{event.CountryName}</td>
                                                    <td className="text-center">{event.Description}</td>
                                                    <td className="text-center">{event.StartDate}</td>
                                                    <td className="text-center">{event.EndDate}</td>
                                                    <td className="text-center">{appType}</td>
                                                    <td className="flex justify-center">
                                                        <button
                                                        className="border border-orange-600 px-1 rounded-lg bg-orange-500 text-white max-sm:flex hover:bg-orange-600"
                                                            onClick={() => AddOrEditEventForm(event.EncEventID)}> <ModeIcon className="mr-1"/>
                                                            Edit
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table> : <p className="text-center font-bold text-3xl mt-20">Record not found...</p>
                    }

                    </div>

                    {/* pagination */}
                    {
                        totalRecord > 1 ?
                        <nav className="flex sm:flex-row-reverse mt-3 max-sm:justify-center text-xl font-bold" aria-label="Page navigation example" >
                            <Pagination
                                count={paginationCount}
                                defaultPage={1}
                                shape="rounded"
                                size="small"
                                page={pages}
                                onChange={handleChange}
                                showFirstButton
                                showLastButton
                                siblingCount={0}
                            />
                        </nav> : null
                    }
                    <div className="max-sm:flex justify-center max-sm:mt-2 font-semibold text-lg" style={{ alignItems: "center" }}> 
                        Records_Total: {totalRecord}
                    
                        <select  value={pageCount} className="ml-5 rounded-lg font-semibold text-lg" onChange={(e)=>setpageHandler(e.target.value)}>
                            {
                                eventsPerPages.map((num)=>{
                                    return <option key={num}>{num}</option>
                                })
                            }
                        </select>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default EventList;


